import { ButtonPrimary, ButtonSize, IconLoader } from '@ui/src';
import BrandForm from '../../../components/settings/details-form/brand-form';
import useBrand from './hooks/use-brand';

import cn from '../styles.module.css';

const PspBrand = () => {
  const {
    isLoading,
    errorList,
    control,
    errors,
    onSubmit,
    fields,
    globalError,
    editIsLoading,
    isDirty,
    setValue,
  } = useBrand();

  let content;

  if (isLoading) {
    content = (
      <div className={cn.settingsLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        {!errorList && (
          <BrandForm
            control={control}
            errors={errors}
            onSubmit={onSubmit}
            brandColor={fields.brandColor}
            companyName={fields.companyName}
            setValue={setValue}
            headerLogo={fields.headerLogo}
            cardLogo={fields.cardLogo}
            favicon={fields.favicon}
            loaderIcon={fields.loaderIcon}
          >
            <>
              {globalError && (
                <div className={cn.saveGlobalError}>{globalError}</div>
              )}
              <ButtonPrimary
                text={editIsLoading ? 'Loading...' : 'Save'}
                onClick={onSubmit}
                bold
                size={ButtonSize.MEDIUM}
                disabled={editIsLoading || !isDirty}
                className={cn.saveDetailsButton}
              />
            </>
          </BrandForm>
        )}
        {errorList && (
          <div className={cn.loadingError}>
            <div className={cn.loadingErrorTitle}>Unable to load data</div>
            <div className={cn.loadingErrorText}>{errorList}</div>
          </div>
        )}
      </>
    );
  }

  return content;
};

export default PspBrand;
